import React, { createContext, useContext } from 'react';
import { useDisclosure } from '@mantine/hooks';
import DataExportFlow from './DataExportFlow';

type DataExportContextType = {
  opened: boolean;
  open: () => void;
  close: () => void;
};

const DataExportContext = createContext<DataExportContextType>({} as DataExportContextType);

export function useDataExport() {
  const context = useContext(DataExportContext);
  if (context === undefined) {
    throw new Error('useDataExport must be used within a DataExportProvider');
  }
  return context;
}

export default function DataExportProvider({ children }: { children: React.ReactNode }) {
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <DataExportContext value={{ opened, open, close }}>
      {children}
      <DataExportFlow opened={opened} close={close} />
    </DataExportContext>
  );
}
